import {
  Component,
  OnInit,
  ElementRef,
  Inject,
  Renderer2
} from '@angular/core';
import { LayoutService } from '../services';

@Component({
  selector: 'sc-tooltip-content',
  template: '<ng-content></ng-content>',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {

  get isMobile(): boolean {
    const point = this.layout.widthSubject.getValue();
    return ['xs', 'sm'].includes(point);
  }

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private layout: LayoutService,
    @Inject('tooltipConfig') private config: any
  ) {}

  ngOnInit() {
    const {
      top,
      left,
      height,
      width
    } = this.config.host.getBoundingClientRect();
    const _el = this.el.nativeElement;

    // set align
    const leftSpace = document.body.offsetWidth - left;
    let align = 'left';
    if (leftSpace < 300) {
      this.renderer.addClass(_el, 'right');
      align = 'right';
    }

    if (!this.config.config.animate) {
      this.renderer.addClass(_el, 'without-animate');
    }

    if (this.config.config.clickable) {
      this.renderer.addClass(_el, 'clickable-area');
    }

    if (this.isMobile) {
      this.renderer.setStyle(_el, 'top', `${top - height + 55}px`);
      this.renderer.setStyle(_el, 'right', `15px`);
    } else {
      this.renderer.setStyle(_el, 'top', `${top - height + 5}px`);
      if (align === 'left') {
        this.renderer.setStyle(_el, 'left', `${left + width + 14}px`);
      } else {
        this.renderer.setStyle(_el, 'right', `${leftSpace + 14}px`);
      }
    }

    const maxWidth = document.body.offsetWidth - _el.offsetLeft - 25;
    this.renderer.setStyle(
      _el,
      'maxWidth',
      `${maxWidth < 500 ? maxWidth : 500}px`
    );

    if (this.config.config.animate) {
      this.renderer.addClass(_el, 'animate');
    }
  }
}
